<!-- =========================================================================================
    File Name: CompanyProductData.vue
    Description: Product Component - Company product data section
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card title="Company Product Data">
      <vs-collapse type="border" accordion class="mb-4">
        <vs-collapse-item
          v-for="data in workingData"
          :key="data.id">
          <div slot="header">
            {{ data.country_code }} |
            MP: {{data.currency_symbol}}{{ data.membership_price }} |
            RP: {{data.currency_symbol}}{{ data.retail_price }}
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Product Url`"
                v-model="data.url"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                label-placeholder="Name"
                v-model="data.name"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-select
                class="w-full mb-1"
                label="Currency Symbol"
                v-model="data.currency_symbol">
                <vs-select-item
                  class="vs-input-shadow-drop vs-select-no-border"
                  v-for="(symbol, index) in currencySymbols"
                  :key="`${symbol}-${index}`"
                  :value="symbol"
                  :text="symbol"
                />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                min="0"
                step="0.25"
                :label-placeholder="`Membership Price`"
                v-model="data.membership_price"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                min="0"
                step="0.25"
                :label-placeholder="`Retail Price`"
                v-model="data.retail_price"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Amount`"
                v-model="data.amount"
                class="w-full"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Amount Unit`"
                v-model="data.amount_unit"
                class="w-full"
              />
            </div>
          </div>
          <vs-row>
            <vs-button @click="update" v-if="unsavedChanges" class="mr-2">Save</vs-button>
            <vs-button type="border" v-if="unsavedChanges" color="warning" @click="revert">Cancel</vs-button>
            <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmDelete(data.id, data.country_code)" />
          </vs-row>
        </vs-collapse-item>
      </vs-collapse>
      <vs-button class="ml-auto" color="primary" type="border" icon-after icon="post_add" @click="newDataDialog = true">New Property</vs-button>
      <vs-prompt
        @accept="create"
        title="New Company Product Data"
        :active.sync="newDataDialog">
        <div class="vx-row mb-2">
          <div class="vx-col w-full mb-1">
            <vs-select
              class="w-full mb-1"
              label="Country Code"
              v-model="formData.country_code">
              <vs-select-item
                class="vs-input-shadow-drop vs-select-no-border"
                v-for="(code, index) in countryCodes"
                :key="`${code}-${index}`"
                :value="code"
                :text="code"
              />
            </vs-select>
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Product Url"
              v-model="formData.url"
            />
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Name"
              v-model="formData.name"
            />
          </div>
          <div class="vx-col w-full mb-1">
            <vs-select
              class="w-full mb-1"
              label="Currency Symbol"
              v-model="formData.currency_symbol">
              <vs-select-item
                class="vs-input-shadow-drop vs-select-no-border"
                v-for="(symbol, index) in currencySymbols"
                :key="`${symbol}-${index}`"
                :value="symbol"
                :text="symbol"
              />
            </vs-select>
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Membership Price"
              v-model="formData.membership_price"
            />
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Retail Price"
              v-model="formData.retail_price"
            />
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Amount"
              v-model="formData.amount"
            />
          </div>
          <div class="vx-col w-full mb-1">
            <vs-input
              class="w-full mb-1"
              label="Amount Unit"
              v-model="formData.amount_unit"
            />
          </div>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import api from '@/http/api';
import { getCurrencyData } from '@/helpers/currencyHelper';
import { getAllCountryCodes } from '@/helpers/countryStateHelper';

export default {
  props: ['productId', 'companyProductData'],
  data() {
    return {
      unsavedChanges: false,
      newDataDialog: false,
      formData: this.getFormData(),
      currencySymbols: getCurrencyData(),
      countryCodes: [],
      originalData: JSON.parse(JSON.stringify(this.companyProductData)),
      workingData: JSON.parse(JSON.stringify(this.companyProductData))
    }
  },
  watch: {
    companyProductData(val) {
      this.originalData = JSON.parse(JSON.stringify(val));
      this.workingData = JSON.parse(JSON.stringify(val));
    },
    originalData: {
      handler: function (val) { this.checkForChanges(val) },
      deep: true
    },
    workingData: {
      handler: function (val) {
        this.checkForChanges(val);
        this.filterCountryCodes();
      },
      deep: true
    }
  },
  methods: {
    async create() {
      const data = this.formatData([this.formData])[0];

      const result = await api.upsertCompanyProductData(this.productId, data);
      if (!result) {
        return this.showNotification(false, `Create was unsuccessful`);
      }

      this.formData = this.getFormData();
      this.showNotification(true, `Update was successful`);
      this.$emit('onProductChange', true);
    },
    async update() {
      const promises = [];
      const data = this.formatData(this.workingData);
      data.forEach(x => promises.push(api.upsertCompanyProductData(this.productId, x)));

      const results = await Promise.all(promises);
      if (results.includes(false)) {
        return this.showNotification(false, `Update was unsuccessful`);
      }

      this.originalData = JSON.parse(JSON.stringify(this.workingData));
      this.showNotification(true, `Update was successful`);
    },
    async deleteProperty(id) {
      const success = await api.deleteCompanyProductData(id, this.productId);
      if (!success) {
        return this.showNotification(false, `Unable to delete company product data`);
      }

      this.workingData = this.workingData.filter(data => data.id !== id);
      this.originalData = this.originalData.filter(data => data.id !== id)

      this.showNotification(true, `Delete was successful`);
    },
    formatData(data) {
      return data.map(x => {
        return {
          ...x,
          retail_price: parseFloat(Number(x.retail_price).toFixed(2)),
          membership_price: parseFloat(Number(x.membership_price).toFixed(2))
        }
      })
    },
    checkForChanges(val) {
      const oldData = JSON.stringify(this.formatData(this.originalData));
      const newData = JSON.stringify(this.formatData(val));
      this.unsavedChanges = oldData !== newData;
    },
    revert() {
      this.workingData = JSON.parse(JSON.stringify(this.originalData));
    },
    confirmDelete(id, countryCode) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        acceptText: 'DELETE',
        title: `Delete ${countryCode} company product data`,
        text: `Are you sure you want to delete (${countryCode}) Company Product Data`,
        accept: () => {
          this.deleteProperty(id);
        }
      })
    },
    showNotification(success, message) {
      this.$vs.notify({
        title: success ? 'Success' : 'Error',
        text: message ? message : '',
        color: success ? 'success' : 'danger',
        icon: success ? 'check_circle_outline' : 'error'});
    },
    filterCountryCodes() {
      const usedCodes = this.workingData ? this.workingData.map(data => data.country_code) : [];
      this.countryCodes = getAllCountryCodes().filter(code => !usedCodes.includes(code));
    },
    getFormData() {
      return {
        country_code: '',
        url: '',
        name: '',
        retail_price: null,
        membership_price: null,
        currency_symbol: '$',
        amount: null,
        amount_unit: ''
      }
    }
  }
}
</script>
